module.exports = __webpack_public_path__ + "static/OpportunityPerspectives_hires-36bc5eace136c825eea20de777a10804.jpg";